import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { MobiUiLanguage, MobiUiMessage } from '@mobi/rwc-ui-components-ng-jslib';
import { Language } from '@mobi/rwc-utils-ng-jslib';

import { AppContext, AppSource } from '../../common.constant';
import { Links } from '../../core/setting/link-data-map';

export const oivCoreSharedActions = createActionGroup({
    source: 'Oiv Core Shared',
    events: {
        source: props<{ source: AppSource }>(),
        context: props<{ context: AppContext }>(),
        language: props<{ language: MobiUiLanguage | Language }>(),
        changeLanguage: props<{ language: MobiUiLanguage | Language }>(),
        mobileMode: props<{ isMobileMode: boolean }>(),
        approvalMode: props<{ isApprovalMode: boolean }>(),
        links: props<{ links: Links }>(),
    },
});

export const oivOverlayActions = createActionGroup({
    source: 'OivOverlay',
    events: {
        open: emptyProps(),
        close: emptyProps(),
    },
});

export const oivAlertActions = createActionGroup({
    source: 'Alert',
    events: {
        add: props<MobiUiMessage>(),
        remove: props<MobiUiMessage>(),
    },
});
